import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Assets/css/layout.css";
import Logo from "../Assets/Img/logo.svg";
import SmallLogo from "../Assets/Img/SmallLogo.svg";
import Home from "../Assets/Img/creators-icon.svg";
import Campaign from "../Assets/Img/campign-icon.svg";
import Insights from "../Assets/Img/insights-icon.svg";
import Message from "../Assets/Img/message.svg";
import Dashboardlogo from "../Assets/Img/dashboard.svg";
import Contacts from "../Assets/Img/contacts.png";
import Users from "../Assets/Img/userprofile.png";
import dashboard from "../Assets/Img/dashboard.svg";

import { GlobalContext } from "../../utils/GlobalContext";
import Brandadminlogo from "../Assets/Img/Brandadminlogo.svg";
import {
  Bell,
  ChevronLeft,
  CreditCard,
  Eye,
  Languages,
  MessageCircle,
  UserRound,
  Wallet,
} from "lucide-react";
import { FaBars } from "react-icons/fa";
import {
  Box,
  Button,
  createTheme,
  ThemeProvider,
  Typography,
} from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#f5f5f5",
    },
  },
});

function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const savedState = localStorage.getItem("isSidebarCollapsed");
    return savedState === "true"; // true if string is 'true'
  });

  const location = useLocation();
  const navigate = useNavigate();
  const { userRole, setUserRole, walletBalance } = useContext(GlobalContext);
  const [selectedMenu, setSelectedMenu] = useState("settings");
  const role = localStorage.getItem("userType");

  useEffect(() => {
    if (!location.pathname.includes("campaign-details")) {
      localStorage.removeItem("activeTab");
      localStorage.removeItem("activeCampaignTab");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!location.pathname.includes("campaign")) {
      localStorage.removeItem("activeTab");
      localStorage.removeItem("activeCampaignTab");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!location.pathname.includes("dashboard-influencer")) {
      localStorage.removeItem("activeTab");
    }
  }, [location.pathname]);

  useEffect(() => {
    const storedRole = localStorage.getItem("userType");
    if (storedRole && setUserRole && typeof setUserRole === "function") {
      setUserRole(storedRole);
    }
  }, [setUserRole]);

  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setSelectedMenu(path || "settings");
  }, [location.pathname]);

  useEffect(() => {
    if (location.state?.showNotificationOnly) {
      setSelectedMenu("notifications");
    } else {
      setSelectedMenu("account-preferences");
    }
  }, [location.state]);

  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem("isSidebarCollapsed", newState);
  };

  const isSettingsPage = location.pathname === "/settings";
  const CURRENT_USER_ROLE = localStorage.getItem("userType");
  const [isDashboardActive, setIsDashboardActive] = useState(false);

  // Reset dashboard active when navigating to other pages
  const handleNavClick = (isDashboard = false) => {
    setIsDashboardActive(isDashboard);
  };

  useEffect(() => {
    const sectionFromState = location?.state?.section;
    if (sectionFromState) {
      setSelectedMenu(sectionFromState);
    }
  }, [location?.state?.section]);

  const formatWalletBalance = (value) => {
    const num = Number(value);

    if (!num) return "0"; // handles 0, null, undefined

    if (num >= 1_000_000_000_000) {
      return (num / 1_000_000_000_000).toFixed(1).replace(/\.0$/, "") + "T";
    }
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    }
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
    }

    return num.toLocaleString() + ""; // 950 → 950 Coins, 999 → 999 Coins
  };

  return (
    <div className={`sidebar-container ${isCollapsed ? "collapsed" : ""}`}>
      <div className={`Sidebar ${isCollapsed ? "collapsed" : ""}`}>
        {/* Toggle Button inside Sidebar */}
        <div className="sidebar-toggle" onClick={toggleSidebar}>
          {isCollapsed ? <FaBars /> : <ChevronLeft />}
        </div>

        {/* Logo */}
        <Link
          className="navbar-brand"
          to={role === "influencer" ? "/influencer-home" : "/brand-home"}
        >
          {isCollapsed ? (
            <img
              src={SmallLogo}
              className="img-fluid logo sidebar"
              alt="Logo"
            />
          ) : (
            <img src={Logo} className="img-fluid logo sidebar" alt="Logo" />
          )}
        </Link>

        <ul className="Sidebar">
          {!isSettingsPage ? (
            CURRENT_USER_ROLE === "admin" ? (
              <>
                <li>
                  <Link
                    to="/admin/influencers"
                    className={
                      location.pathname === "/admin/influencers" ? "active" : ""
                    }
                  >
                    <img src={Users} alt="Influencersn" className="icon" />
                    {!isCollapsed && "Influencers"}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admin/brand"
                    className={
                      location.pathname === "/admin/brand" ? "active" : ""
                    }
                  >
                    <img src={Brandadminlogo} alt="Brand" className="icon" />
                    {!isCollapsed && "Brand"}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contactsdashboard"
                    className={
                      location.pathname === "/contactsdashboard" ? "active" : ""
                    }
                  >
                    <img src={Contacts} alt="Contacts" className="icon" />
                    {!isCollapsed && "Contacts"}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/dashboardqueries"
                    className={
                      location.pathname === "/dashboardqueries" ? "active" : ""
                    }
                  >
                    <img src={Dashboardlogo} alt="Queries" className="icon" />
                    {!isCollapsed && "Queries"}
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link
                    to={
                      role === "influencer" ? "/influencer-home" : "/brand-home"
                    }
                    onClick={() => handleNavClick(false)}
                    className={
                      !isDashboardActive &&
                      ((role === "influencer" &&
                        (location.pathname === "/influencer-home" ||
                          location.pathname.startsWith(
                            "/influancer-details"
                          ))) ||
                        (role !== "influencer" &&
                          location.pathname === "/brand-home") ||
                        location.pathname.startsWith("/influencer"))
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={role === "influencer" ? Campaign : Home}
                      alt={role === "influencer" ? "Home" : "Campaign"}
                      className="icon"
                    />
                    {!isCollapsed &&
                      (role === "influencer" ? "All Campaigns" : "Creators")}
                  </Link>
                </li>

                <li>
                  <Link
                    to={
                      role === "influencer"
                        ? "/dashboard-influencer"
                        : "/campaign"
                    }
                    onClick={() => handleNavClick(true)}
                    className={
                      (role === "influencer" &&
                        isDashboardActive &&
                        (location.pathname === "/dashboard-influencer" ||
                          location.pathname.startsWith(
                            "/influancer-details"
                          ))) ||
                      (role !== "influencer" &&
                        location.pathname === "/campaign") ||
                      location.pathname === "/campaign-create" ||
                      location.pathname.startsWith("/campaign-details")
                        ? "active"
                        : ""
                    }
                  >
                    <img
                      src={
                        role === "influencer"
                          ? // location.pathname === "/dashboard-influencer"
                            //   ||
                            // (role !== "influencer" &&
                            //   location.pathname === "/dashboard"
                            // )
                            dashboard
                          : Campaign
                      }
                      alt={role === "influencer" ? "Dashboard" : "Campaign"}
                      className="icon"
                    />
                    {!isCollapsed &&
                      (role === "influencer" ? "Dashboard" : "Campaign")}
                  </Link>
                </li>

                <li>
                  <Link
                    to="/insightsHome"
                    className={
                      location.pathname === "/insightsHome"
                        ? "active"
                        : "" ||
                          location.pathname.startsWith("/insightsDeliverables")
                        ? "active"
                        : ""
                    }
                  >
                    <img src={Insights} alt="Insights" className="icon" />
                    {!isCollapsed && "Track"}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/message"
                    className={location.pathname === "/message" ? "active" : ""}
                  >
                    <img src={Message} alt="Message" className="icon" />
                    {!isCollapsed && "Message"}
                  </Link>
                </li>

              
                {role === "influencer" ? (
                  <li>
                    <Link
                      to="/my-wallet"
                      className={
                        location.pathname === "/my-wallet" ? "active" : ""
                      }
                    >
                      <span
                        style={{
                          display: "block",
                          gap: "8px",
                          width: "100%",
                        }}
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <Wallet color="rgba(101, 101, 101, 1)" />
                          {!isCollapsed && "My Wallet"}
                        </span>

                        {/* {!isCollapsed && (
                          <span
                            style={{
                              // marginLeft: "auto",
                              fontWeight: "600",
                              fontSize: "14px",
                              color: "#6B8E76",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {formatWalletBalance(walletBalance)}
                          </span>
                        )} */}
                      </span>
                    </Link>
                  </li>
                ) : (
                  <>
                    {/* <li> */}
                    <span
                      style={{
                        display: "block",
                        gap: "8px",
                        width: "100%",
                        height: "68px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {/* <Typography>kanj</Typography> */}
                      </span>
                    </span>
                    {/* </li> */}
                  </>
                )}
              </>
            )
          ) : (
            <ul className="settings-menu">
              <li
                className={
                  selectedMenu === "account-preferences" ? "active" : ""
                }
                onClick={() => setSelectedMenu("account-preferences")}
              >
                <Link
                  to="/settings"
                  state={{ section: "account-preferences" }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <UserRound
                    size={18}
                    color={
                      selectedMenu === "account-preferences"
                        ? "rgba(107, 142, 118, 1)"
                        : "rgba(101, 101, 101, 1)"
                    }
                  />
                  {!isCollapsed && (
                    <span
                      style={{
                        fontSize: "12px",
                        marginLeft: "4px",
                        color:
                          selectedMenu === "account-preferences"
                            ? "rgba(107, 142, 118, 1)"
                            : "rgba(101, 101, 101, 1)",
                      }}
                    >
                      Account Settings
                    </span>
                  )}
                </Link>
              </li>

              <li
                className={selectedMenu === "notifications" ? "active" : ""}
                onClick={() => setSelectedMenu("notifications")}
              >
                <Link
                  to="/settings"
                  state={{
                    section: "notifications",
                    showNotificationOnly: true,
                  }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Bell
                    size={18}
                    color={
                      selectedMenu === "notifications"
                        ? "rgba(107, 142, 118, 1)"
                        : "rgba(101, 101, 101, 1)"
                    }
                  />
                  {!isCollapsed && (
                    <span
                      className="ms-1"
                      style={{
                        color:
                          selectedMenu === "notifications"
                            ? "rgba(107, 142, 118, 1)"
                            : "rgba(101, 101, 101, 1)",
                      }}
                    >
                      Notifications
                    </span>
                  )}
                </Link>
              </li>

              <li
                className={
                  selectedMenu === "Privacy & Visibility" ? "active" : ""
                }
                onClick={() => setSelectedMenu("Privacy & Visibility")}
              >
                <Link
                  to="/settings"
                  state={{ section: "Privacy & Visibility" }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Eye
                    size={18}
                    color={
                      selectedMenu === "Privacy & Visibility"
                        ? "rgba(107, 142, 118, 1)"
                        : "rgba(101, 101, 101, 1)"
                    }
                  />
                  {!isCollapsed && (
                    <span
                      style={{
                        fontSize: "12px",
                        marginLeft: "4px",
                        color:
                          selectedMenu === "Privacy & Visibility"
                            ? "rgba(107, 142, 118, 1)"
                            : "rgba(101, 101, 101, 1)",
                      }}
                    >
                      Privacy & Visibility
                    </span>
                  )}
                </Link>
              </li>

              <li
                className={selectedMenu === "Payment & Billing" ? "active" : ""}
                onClick={() => setSelectedMenu("Payment & Billing")}
              >
                <Link
                  to="/settings"
                  state={{ section: "Payment & Billing" }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <CreditCard
                    size={18}
                    color={
                      selectedMenu === "Payment & Billing"
                        ? "rgba(107, 142, 118, 1)"
                        : "rgba(101, 101, 101, 1)"
                    }
                  />
                  {!isCollapsed && (
                    <span
                      style={{
                        fontSize: "12px",
                        marginLeft: "4px",
                        color:
                          selectedMenu === "Payment & Billing"
                            ? "rgba(107, 142, 118, 1)"
                            : "rgba(101, 101, 101, 1)",
                      }}
                    >
                      Payment & Billing
                    </span>
                  )}
                </Link>
              </li>

              <li
                className={selectedMenu === "Language & Region" ? "active" : ""}
                onClick={() => setSelectedMenu("Language & Region")}
              >
                <Link
                  to="/settings"
                  state={{ section: "Language & Region" }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Languages
                    size={18}
                    color={
                      selectedMenu === "Language & Region"
                        ? "rgba(107, 142, 118, 1)"
                        : "rgba(101, 101, 101, 1)"
                    }
                  />
                  {!isCollapsed && (
                    <span
                      style={{
                        fontSize: "12px",
                        marginLeft: "4px",
                        color:
                          selectedMenu === "Language & Region"
                            ? "rgba(107, 142, 118, 1)"
                            : "rgba(101, 101, 101, 1)",
                      }}
                    >
                      Language & Region
                    </span>
                  )}
                </Link>
              </li>

              <li
                className={
                  selectedMenu === "Support & Feedback" ? "active" : ""
                }
                onClick={() => setSelectedMenu("Support & Feedback")}
              >
                <Link
                  to="/settings"
                  state={{ section: "Support & Feedback" }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <MessageCircle
                    size={18}
                    color={
                      selectedMenu === "Support & Feedback"
                        ? "rgba(107, 142, 118, 1)"
                        : "rgba(101, 101, 101, 1)"
                    }
                  />
                  {!isCollapsed && (
                    <span
                      style={{
                        fontSize: "12px",
                        marginLeft: "4px",
                        color:
                          selectedMenu === "Support & Feedback"
                            ? "rgba(107, 142, 118, 1)"
                            : "rgba(101, 101, 101, 1)",
                      }}
                    >
                      Support & Feedback
                    </span>
                  )}
                </Link>
              </li>
            </ul>
          )}
        </ul>

        <div
          className={`Sidebar ${isCollapsed ? "collapsed" : ""}`}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "55vh",
          }}
        >
          {/* Logo, Toggle Button, and <ul> menu come here */}

          {/* Ask AI Button - FIXED TO BOTTOM */}
          <ThemeProvider theme={theme}>
            <Box
              sx={{
                mt: "auto",
                py: 2,
                px: isCollapsed ? 4.5 : 2,
                display: "flex",
                justifyContent: "center",
                marginBottom: "32px !important",
              }}
            >
              <Button
                variant="contained"
                onClick={() => navigate("/Chatbot")}
                sx={{
                  backdropFilter: "blur(6px)",
                  background: `
          /* White blur overlay */
          linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),

          /* NEW Left Radiant Green Glow */
          linear-gradient(90deg, rgba(107, 142, 118, 0.55) 0%, rgba(107, 142, 118, 0) 45%),

          /* Existing green soft overlays */
          linear-gradient(25.61deg, rgba(107, 142, 118, 0) 29.07%, rgba(107, 142, 118, 0.1) 94.36%),
          linear-gradient(59.96deg, rgba(107, 142, 118, 0.2) 10.06%, rgba(107, 142, 118, 0) 50.1%)
        `,
                  border: "2px solid",
                  borderImageSource: `
          linear-gradient(90.03deg,
            rgba(140, 148, 171, 0.3) 0.03%,
            rgba(255, 255, 255, 0.6) 11.57%,
            rgba(255, 255, 255, 0.6) 87.79%,
            rgba(140, 148, 171, 0.3) 99.97%
          )
        `,
                  borderRadius: "999px",
                  padding: isCollapsed ? "8px 12px" : "10px 24px",
                  fontSize: "16px",
                  fontFamily: '"Poppins",sans-serif',
                  fontWeight: "600 !important",
                  textTransform: "none",
                  boxShadow: `
          0px 8px 10px 0px rgba(255, 255, 255, 0.2),
          0px 4px 4px 0px rgba(255, 255, 255, 0.1)
        `,
                  borderColor: "transparent",
                  minWidth: isCollapsed ? "auto" : "160px",
                  width: isCollapsed ? "40px" : "auto",
                  justifyContent: "center",
                  "& span": {
                    background: isCollapsed
                      ? "none"
                      : "radial-gradient(71.7% 135.42% at 49.77% 79.17%, #6B8E76 0%, #2D2D2D 100%)",
                    WebkitBackgroundClip: isCollapsed ? "initial" : "text",
                    WebkitTextFillColor: isCollapsed
                      ? "inherit"
                      : "transparent",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                    boxShadow: `
            0px 8px 12px rgba(255, 255, 255, 0.25),
            0px 4px 6px rgba(255, 255, 255, 0.15)
          `,
                  },
                }}
              >
                {isCollapsed ? "🤖" : "Ask AI"}
              </Button>
            </Box>
          </ThemeProvider>
        </div>
      </div>
      {/* Ask AI Button at the Bottom */}
    </div>
  );
}

export default Sidebar;
